import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-8">
          <ArrowLeft className="mr-2" size={20} />
          Zurück zur Homepage
        </Link>
        
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Impressum und Datenschutzerklärung</h1>
          
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Impressum</h2>
            <div className="space-y-2 text-gray-700">
              <p><strong>Firma:</strong> SRC Global GmbH</p>
              <p><strong>Adresse:</strong> Chaltenbodenstrasse 26</p>
              <p><strong>PLZ / Ort:</strong> 8834 Schindellegi</p>
              <p><strong>Telefon:</strong> +41 44 722 32 35</p>
              <p><strong>E-Mail:</strong> <a href="mailto:info@srcglobal.earth" className="text-green-600 hover:underline">info@srcglobal.earth</a></p>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Datenschutzerklärung</h2>
            
            <div className="space-y-6 text-gray-700">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Allgemeines</h3>
                <p>
                  Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Personenbezogene Daten werden 
                  vertraulich und gemäss den gesetzlichen Datenschutzvorschriften behandelt.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Hosting</h3>
                <p className="mb-2">
                  Unsere Website wird bei Hostpoint AG, Neue Jonastrasse 60, 8640 Rapperswil-Jona, Schweiz 
                  gehostet. Beim Besuch unserer Website werden automatisch Informationen in sogenannten 
                  Server-Logfiles gespeichert, darunter:
                </p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>IP-Adresse des zugreifenden Rechners</li>
                  <li>Datum und Uhrzeit des Zugriffs</li>
                  <li>Browsertyp und Browserversion</li>
                  <li>verwendetes Betriebssystem</li>
                  <li>Referrer URL</li>
                </ul>
                <p className="mt-2">
                  Diese Daten werden ausschliesslich zum Zweck des sicheren Betriebs der Website erhoben und 
                  nach einer angemessenen Frist automatisch gelöscht. Eine Zusammenführung mit anderen 
                  Datenquellen erfolgt nicht.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Kontaktaufnahme</h3>
                <p>
                  Wenn Sie uns per E-Mail oder Telefon kontaktieren, werden die von Ihnen übermittelten Daten 
                  (z. B. Name, Telefonnummer, E-Mail-Adresse, Anliegen) ausschliesslich zur Bearbeitung Ihrer 
                  Anfrage verwendet.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Terminbuchung über Calendly</h3>
                <p>
                  Für die Online-Terminbuchung nutzen wir den Dienst Calendly. Wenn Sie einen Termin buchen, 
                  werden Ihre Angaben (z. B. Name, E-Mail, gewünschter Termin) direkt an Calendly LLC, 
                  115 E Main St #A1, Buford, GA 30518, USA übermittelt. Weitere Informationen zur 
                  Datenverarbeitung durch Calendly finden Sie hier:{' '}
                  <a 
                    href="https://calendly.com/privacy" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-green-600 hover:underline"
                  >
                    https://calendly.com/privacy
                  </a>
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;